(() => {
  'use strict';

  if (window.PaulissenButaanFilterUiReady) return;
  window.PaulissenButaanFilterUiReady = true;

  const sectionSelector = '[data-results-section]';
  const butaanPathPattern = /\/butaan\/?$/i;

  const baseUrl = () => {
    const url = new URL(window.location.href);
    url.pathname = url.pathname.replace(butaanPathPattern, '') || '/';
    url.searchParams.delete('page');
    return url;
  };

  const isActive = () => butaanPathPattern.test(window.location.pathname);

  const removeButaan = () => {
    const checkbox = document.querySelector(`${sectionSelector} [data-pw-tag-filter="butaan"]`);
    if (checkbox instanceof HTMLInputElement) {
      checkbox.checked = false;
      checkbox.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    window.location.assign(baseUrl());
  };

  const render = () => {
    const section = document.querySelector(sectionSelector);
    if (!section || !isActive()) return;

    let active = section.querySelector('.pw-active-filters');
    if (!active) {
      active = document.createElement('div');
      active.className = 'pw-active-filters';
      active.setAttribute('aria-label', 'Actieve filters');
      active.innerHTML = '<span class="pw-active-filters__label">Actieve filters:</span>';
      section.querySelector('.pw-results-toolbar')?.insertAdjacentElement('afterend', active);
    }

    if (active && !active.querySelector('[data-pw-butaan-chip]')) {
      const chip = document.createElement('a');
      chip.className = 'pw-filter-chip';
      chip.href = baseUrl().toString();
      chip.dataset.pwButaanChip = '';
      chip.innerHTML = 'Soort: Butaan <span aria-hidden="true">×</span>';
      const clearAll = active.querySelector('.pw-active-filters__clear');
      if (clearAll) active.insertBefore(chip, clearAll);
      else active.append(chip);
    }

    if (active && !active.querySelector('.pw-active-filters__clear')) {
      const clearAll = document.createElement('a');
      clearAll.className = 'pw-active-filters__clear';
      const clean = baseUrl();
      clean.search = '';
      clearAll.href = clean.toString();
      clearAll.textContent = 'Alle filters wissen';
      active.append(clearAll);
    }

    const summary = section.querySelector('.pw-facets__panel > summary');
    if (summary && !summary.querySelector('[data-pw-butaan-count]')) {
      let badge = summary.querySelector('.pw-facets__count');
      if (badge) {
        const count = Number.parseInt(badge.textContent || '0', 10) || 0;
        badge.textContent = String(count + 1);
        badge.dataset.pwButaanCount = '';
      } else {
        badge = document.createElement('span');
        badge.className = 'pw-facets__count';
        badge.dataset.pwButaanCount = '';
        badge.textContent = '1';
        summary.append(badge);
      }
    }
  };

  document.addEventListener('click', (event) => {
    const chip = event.target.closest('[data-pw-butaan-chip]');
    if (!chip) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    removeButaan();
  });

  const schedule = () => window.requestAnimationFrame(render);
  document.addEventListener('DOMContentLoaded', render, { once: true });
  document.addEventListener('shopify:section:load', render);
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();
